// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 实体结构类型枚举 枚举类
 * 实体结构类型枚举
 */
export enum EnumEntityStructureType {
  /** 单实体 : 简单的单实体 */
  SingleEntity = 1,
  /** 树形实体 : 拥有上下级关系的树形结构实体 */
  TreeEntity = 2
}

/**
 * 实体结构类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumEntityStructureTypeMD {
  private static items = [
    new EnumItemMD('SingleEntity', 1, '单实体', '简单的单实体'),
    new EnumItemMD('TreeEntity', 2, '树形实体', '拥有上下级关系的树形结构实体')
  ];

  static getItem(enumItem: EnumEntityStructureType) {
    return this.items.find(item => item.name === EnumEntityStructureType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
